/**
 * Custom hook for managing personas
 */

import { useState, useEffect } from 'react';
import { DEFAULT_PERSONAS } from './defaultPersonas';

export function usePersonas() {
  const [personas, setPersonas] = useState(() => {
    const saved = localStorage.getItem('personas');
    if (saved) {
      return JSON.parse(saved);
    }
    return DEFAULT_PERSONAS;
  });

  const [selectedPersona, setSelectedPersona] = useState(() => {
    const saved = localStorage.getItem('selected_persona');

    // Get current personas list for validation
    const savedPersonas = localStorage.getItem('personas');
    const currentPersonas = savedPersonas ? JSON.parse(savedPersonas) : DEFAULT_PERSONAS;

    // Validate saved persona exists
    if (saved) {
      const exists = currentPersonas.some(p => p.name === saved);
      if (exists) {
        return saved;
      }
    }

    const defaultPersona = currentPersonas.length > 0 ? currentPersonas[0].name : null;
    return defaultPersona;
  });

  // Save personas to localStorage when changed
  useEffect(() => {
    localStorage.setItem('personas', JSON.stringify(personas));
  }, [personas]);

  // Save selected persona to localStorage when changed
  useEffect(() => {
    if (selectedPersona) {
      localStorage.setItem('selectedPersona', selectedPersona);
    }
  }, [selectedPersona]);

    // Validate selected persona when personas list changes
  useEffect(() => {
    if (selectedPersona && !personas.some(p => p.name === selectedPersona)) {
      // Selected persona no longer exists, reset to first persona
      if (personas.length > 0) {
        setSelectedPersona(personas[0].name);
      } else {
        setSelectedPersona(null);
      }
    }
  }, [personas]); // Only depend on personas, not selectedPersona

  return {
    personas,
    setPersonas,
    selectedPersona,
    setSelectedPersona
  };
}

export default usePersonas;
